import { useRef } from "react";
export function useSessionTimer() {
    var startTime = useRef(null);
    function start() {
        startTime.current = new Date();
    }
    function getDuration(status) {
        if (!startTime.current)
            return "00:00:00";
        var end = new Date();
        var ms = status === "New" ||
            status === "Checking" ||
            status === "Failed" ||
            status === "NotSupported"
            ? 0
            : end.getTime() - startTime.current.getTime();
        var delta = Math.round(ms / 1000);
        var h = Math.floor(delta / 3600)
            .toString()
            .padStart(2, "0");
        var m = Math.floor((delta % 3600) / 60)
            .toString()
            .padStart(2, "0");
        var s = (delta % 60).toString().padStart(2, "0");
        return "".concat(h, ":").concat(m, ":").concat(s);
    }
    return { start: start, getDuration: getDuration };
}
